<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-switch
        v-model="
          menuSetting.orderDescription.isValidListingCategoryClassification
        "
        label="上場区分"
        class="v-input--reverse"
      />
    </v-flex>
    <v-flex
      v-if="menuSetting.orderDescription.isValidListingCategoryClassification"
      xs10
      offset-xs1
    >
      <div
        v-if="listingTarget.listingCategoryClassificationTargets.length === 0"
        class="red--text pb-2"
      >
        上場区分を一つ以上選択してください。
      </div>
      <div
        v-for="option in listedOptions"
        :key="option.key"
        class="horizontal-list"
      >
        <input v-model="option.value" class="checkbox-input" type="checkbox" />
        <label class="checkbox-text">{{ option.name }}</label>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { OfficeListedOptions } from '@/models/Menu/Constants'
export default {
  name: 'CampaignModalPageOfficeOptionsCheckbox',
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      listedOptions: [],
    }
  },
  computed: {
    listingTarget() {
      return this.menuSetting.orderDescription
        .listingCategoryClassificationTarget
    },
  },
  watch: {
    listedOptions: {
      handler(value) {
        this.menuSetting.makeListingCategoryClassification(value)
      },
      deep: true,
    },
  },
  created() {
    this.listedOptions = OfficeListedOptions.map(option => {
      return {
        ...option,
        value:
          this.listingTarget.listingCategoryClassificationTargets.indexOf(
            option.key,
          ) !== -1,
      }
    })
  },
  methods: {
    validate() {
      if (
        !this.menuSetting.orderDescription.isValidListingCategoryClassification
      ) {
        return true
      }
      return (
        this.listingTarget.listingCategoryClassificationTargets.length !== 0
      )
    },
  },
}
</script>

<style scoped lang="scss">
.horizontal-list {
  display: inline-block;
  margin-left: 25px;
  margin-bottom: 15px;
}

.checkbox-input {
  width: 15px;
  height: 15px;
}

.checkbox-text {
  font-size: 20px;
  margin-left: 10px;
}

.v-input--reverse {
  ::v-deep .v-input__slot {
    flex-direction: row-reverse;
    .v-input--selection-controls__input {
      margin-left: 8px;
    }
  }
}
</style>
